import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { ModuleComponent } from "../module.component";
import { GuideService } from "../../services/guide.service";
import { ScrollToService } from "ng2-scroll-to-el";
import { IdentityService } from "../../../services/identity.service";
import { ToastrService } from "ngx-toastr";

@Component({
  templateUrl: "./3A.component.html",
  styleUrls: ["../component.css"]
})
export class _3AComponent extends ModuleComponent {

  A12: string = `<ol type="a"><li>Childcare: </li><li>Adult Care: </li><li>Planned trips/events: </li><li>Existing PT/FT job: </li></ol>`;
  A13: string = `<ol type="a"><li>State Identification / Passport: </li><li>Social Security Card / Green Card: </li><li>Veteran documents: </li><li>How many dependents: </li></ol>`;
  A22: string = `Some examples include paid a fair wage, opportunity for promotion, steady hours, work well with boss or co-workers.`;
  A32: string = ` `;

  constructor(router: Router, guideService: GuideService, modalService: BsModalService, scrollService: ScrollToService, identitySrv: IdentityService, toastr: ToastrService) {
    super(router, scrollService, guideService, modalService, identitySrv, toastr);

    this.titles.push({
      "activityId": "A11",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> how to decide if a job would be a good fit.`
    });
    this.titles.push({
      "activityId": "A12",
      "html": `<i class="fas fa-sticky-note"></i><strong>Identify</strong> obligations you have to meet if you are offered a job`
    });
    this.titles.push({
      "activityId": "A13",
      "html": `<i class="fas fa-sticky-note"></i><strong>Identity</strong> the documents you need to begin a job `
    });
    this.titles.push({
      "activityId": "A14",
      "html": `<i class="fas fa-mouse-pointer"></i><strong>Complete</strong> the activity response: Update your career plan dates for 'Prepare to accept a job'`
    });


    this.titles.push({
      "activityId": "A21",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about things to get ready for your first day on the job.`
    });
    this.titles.push({
      "activityId": "A22",
      "html": `<i class="fas fa-sticky-note"></i> <strong>Identify</strong> your expectations of the job`
    });
    this.titles.push({
      "activityId": "A23",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for 'Learn about filing taxes'`
    });


    this.titles.push({
      "activityId": "A31",
      "html": `<i class="fas fa-file-import"></i> Review workplace skills and actions to keep your new job and learn about job performance criteria for your new job.`
    });
    this.titles.push({
      "activityId": "A32",
      "html": `<i class="fas fa-sticky-note"></i> <strong>Identify</strong> possible career ladder moves based upon your chosen career path.`
    });
    this.titles.push({
      "activityId": "A33",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> this activity you will update the career plan dates for the step 'Career Advancement'`
    });

    this.titles.push({
      "activityId": "A41",
      "html": `<i class="fas fa-file-import"></i> Test your knowledge of what you learned. These questions will be on the post-assessment test.`
    });

    this.group = 2;
    this.alpha = "A";

    this.activeMod = { group: 2, alpha: "A", number: 1 };
  }

  ngOnInit() {    
  }

  ngAfterViewInit() {
    this.loadGuide();
  }
}
